let configure = 2;//0是测试环境，1是安检环境，2是线上环境
let B_BASEURL;//后端地址
let F_BASEURL;//前端地址

if(configure == 0){
  B_BASEURL = "http://60.166.4.238:48081/wxfw/yxhd";//测试
  F_BASEURL = "http://60.166.4.238:48081/wxfw/resource/activity/2022";
}else if(configure == 1){
  B_BASEURL = "https://wx.gyzq.com.cn/wxfw/servlet/anjian2";//安检
  F_BASEURL = "https://wx.gyzq.com.cn/wxfw/activity/2022/anjian";
}else{
  B_BASEURL = "https://wx.gyzq.com.cn/wxfw/servlet/api";//生产
  F_BASEURL = "https://wx.gyzq.com.cn/wxfw/activity/2022";
}

let config = {
  B_BASEURL: B_BASEURL,
  F_BASEURL: F_BASEURL,
  imgCodeBaseURL: B_BASEURL, // 图片验证码地址
  imgBaseURL: "https://wx.gyzq.com.cn/wxfw", // 图片资源域名地址
};

export default config;
